import {
  Component,
  ViewEncapsulation,
  OnInit, Inject, OnDestroy, ChangeDetectorRef, ViewChild, AfterViewInit
} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {DOCUMENT} from '@angular/common';
import {UserContext} from '../services/user-context';
import {ApiService} from '../services/api';
import {Observable, Subscription} from 'rxjs';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {DataStateChangeEvent, GridComponent, GridDataResult, SelectionEvent} from '@progress/kendo-angular-grid';
import {Collection} from '../models/collection.model';
import {Variant} from '../models/variant.model';
import {Product} from '../models/product.model';
import {ShopifyService} from '../services/shopify/shopify.service';
import {State} from '@progress/kendo-data-query';
import {LoadingIndicatorService} from '../shared/layout/components/loading-indicator';
import {ProfileDialogComponent} from '../profile/profile-dialog.component';
import {ConfirmDialogComponent} from '../shared/layout/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-curate',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'curate.template.html',
  styleUrls: [
    './curate.style.scss'
  ]
})
export class CurateComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('productCatalogGrid',{static:false}) private productGrid:GridComponent;

  private subscription: Subscription;

  form: FormGroup;

  curations: any[];
  selectedNode: any;
  selectedLeaf: any;
  selectedKeys: any[] = [];
  expandedKeys: any[] = [];
  items:any[] = [];
  adding: boolean;
  name: string;
  newNode:any;
  namePrompt;

  productView: Observable<GridDataResult>;
  collection:Collection;
  selectedProductKeys:string[] = [];
  productSearchTerm = '';
  selectedProducts:Product[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private cd: ChangeDetectorRef,
    public dialog: MatDialog,
    private api: ApiService,
    public loadingService: LoadingIndicatorService,
    private shopService: ShopifyService,
    private snackBar: MatSnackBar,
    private userContext: UserContext,
    @Inject(DOCUMENT) private document: Document) {

    this.api.get<any[]>( "/curation" ).subscribe((result) => {
      this.curations = result || [];

      if( !this.curations.length ) {
        this.curations.push({shared: false, name: "Folders", type: "folder", nodes: [
            {name: "Example Folder", type: "folder", nodes: [{name: "Example Collection", type: "collection", items:[]}]}
          ], items: []});
      }
      this.expandTree("0");
    });
    this.shopService.setShopForCountry(this.userContext.account.country || 'us');

    this.productView = shopService;
  }

  public iconForNode(node:any):string {
    if (node.type === 'folder' ) {
      return "folder_open"
    } else if( node.type === 'collection' ) {
      return "shopping_cart"
    } else {
      return "";
    }
  }

  public ngOnInit(): void {
  }

  public ngAfterViewInit(): void {
    this.expandTree("0");
  }

  public ngOnDestroy(): void {
  }

  public collapseTree(): void {
    this.expandedKeys = this.expandedKeys.filter(k => !k.startsWith(this.selectedLeaf.item.index));
  }

  public folderKeys(prefix:string, nodes:any[]):string[] {
    let keys:string[] = [];

    for (const [i, n] of (nodes || []).entries()) {
      if( n.type === 'folder') {
        let currentPrefix = `${prefix}${prefix.length ? "_" : ""}${i}`;
        keys.push(currentPrefix);
        keys = keys.concat(this.folderKeys(currentPrefix, n.nodes || []));
      }
    }

    return keys;
  }

  public expandTree(start?:string): void {
    if( !this.curations ) {
      return;
    }
    let expanded = [];
    expanded.push(start || this.selectedLeaf.item.index);
    expanded = expanded.concat(this.folderKeys(start || this.selectedLeaf.item.index, (this.selectedNode || this.curations[0]).nodes || []));
    this.expandedKeys = this.expandedKeys.filter(k => !expanded.includes(k)).concat(expanded);
  }

  onNodeSelect(node:any) {
    this.clear();
    this.selectedLeaf = node;
    this.selectedNode = node.item.dataItem;
    if( this.selectedNode.type === 'collection') {
      //inflate

      let map = this.shopService.products.reduce((agg, curr) => {agg[curr.id] = curr; return agg;}, {});
      this.selectedProducts = [];
      for( const id of this.selectedNode.items || [] ) {
        let product = map[id];
        if( product ) {
          this.selectedProducts.push( product );
        }
      }
      this.selectedProductKeys = this.selectedNode.items || [];
    }
    console.log("Node is :" + JSON.stringify(this.selectedLeaf,null,4));
  }

  addNode() {
    console.log("Adding node to " + this.selectedNode.name + " " + this.selectedKeys + " " + this.expandedKeys);
    this.newNode.name = this.name;
    this.selectedNode.nodes.push(this.newNode);

    if( !this.expandedKeys.includes(this.selectedLeaf.item.index) ) {
      this.expandedKeys.push( this.selectedLeaf.item.index );
    }
    this.selectedKeys = [`${this.selectedLeaf.item.index}_${this.selectedNode.nodes.length - 1}` ];
    this.name = null;
    this.namePrompt = null;
    this.selectedNode = this.newNode;
    this.newNode = null;
    this.cd.detectChanges();
    this.save();
    console.log("Added node to " + "s " + this.selectedKeys + "e " + this.expandedKeys);
  }

  clear() {
    this.newNode = null;
    this.name = null;
    this.namePrompt = null;

  }

  cancel() {
    this.selectedKeys = [];
    this.selectedNode = null;
    this.clear();
  }

  findParent(node:any, index:string):any {
    let indicies = index.split("_");

    if( !node && indicies.length) {
      node = this.curations[indicies.shift()];
    }
    console.log("Finding node " + JSON.stringify(indicies) + " from " + node.name);
    if( indicies.length === 1 ) {
      return node;
    } else {
      let next = node.nodes[indicies[0]];
      indicies.splice(0, 1);
      return this.findParent(next, indicies.join("_"));
    }
  }

  remove() {
    if( this.selectedNode.type === 'collection' || (this.selectedNode.nodes || []).length) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '300px',
        data: {message: `Remove ${this.selectedNode.name}?`}
      });

      dialogRef.afterClosed().subscribe(result => {
        if ( result.confirm ) {
          this.removeChild();
        }
      });
    } else {
      this.removeChild();
    }
  }

  removeChild() {
    let parent = this.findParent(null, this.selectedLeaf.item.index);
    let childIndex = parseInt(this.selectedLeaf.item.index.split("_").pop());
    parent.nodes.splice(childIndex,1);
    this.selectedNode = null;
    this.selectedKeys = [];
    this.save();
  }

  isRemovable():boolean {
    let curationIndex = this.selectedLeaf.item.index.split("_")[0];
    if( this.curations[curationIndex].shared ) {
      return false;
    }
    return this.selectedLeaf.item.index.indexOf("_") > 0;
  }

  addFolder() {
    this.namePrompt = 'Folder Name'
    this.newNode = {type:'folder', nodes:[]};
  }

  addCollection() {
    this.namePrompt = 'Collection Name'
    this.newNode = {type:'collection', items:[]};
  }

  public productStateChange(state: DataStateChangeEvent): void {
    this.productState = state;
    this.getProducts();
  }

  public productSelectionUpdated(event:any) {
    let deselected = <string[]>event.deselectedRows.map(d => d.dataItem.id);
    this.selectedProducts = this.selectedProducts.filter(p => !deselected.includes(p.id)).concat(<Product[]>event.selectedRows.map(p => p.dataItem));
    console.log("Selected: " + JSON.stringify(event,null,4));
  }

  public removeSelectedProduct(selected:any) {
    this.selectedProducts = this.selectedProducts.filter(p => p.id !== selected.id);
    this.selectedProductKeys = this.selectedProductKeys.filter(p => p !== selected.id);
  }

  public saveCollection() {

    this.selectedNode.items = this.selectedProductKeys;
    this.save();
    this.selectedProductKeys = [];
    this.selectedProducts = [];
    this.selectedKeys = [];
    this.selectedNode = null;
  }

  public save() {

    for (const [i, curation] of (this.curations || []).entries()) {
      if (!curation.shared) {
        if (!curation.id) {
          this.api.post<any>(`/curation`, curation).subscribe(result => {
            if (result) {
              this.curations.splice(i, 1, result);
              this.selectedKeys = [];
              this.selectedNode = null;
              this.selectedLeaf = null;
            }
            this.snackBar.open('Curated collections saved.', null, {
              duration: 2000
            });
          });
        } else {
          this.api.patch<any>(`/curation/${curation.id}`, curation).subscribe(result => {
            if (result) {
              //this.curations.splice(i, 1, result);
            }
            this.snackBar.open('Curated collections updated.', null, {
              duration: 2000
            });
          });
        }
      }
    }
  }

  public productState: State = {
    skip: 0,
    take: 5
  };

  public variantSelected(event:SelectionEvent) {
    let deselected = event.deselectedRows.map(r => r.dataItem.id);
    this.selectedProducts = this.selectedProducts.filter( p => !deselected.includes(p.id) ).concat(event.selectedRows.map( r => r.dataItem));
    this.selectedProductKeys = this.selectedProducts.map(p => p.id);
  }

  public collectionChange(value:Collection) {
    this.collection = value;
    console.log("Changed collection to: " + value.title);
    this.productState = {
      skip: 0,
      take: 5
    };
    this.getProducts();
  }


  public productFilter(inputValue: string): void {
    this.productSearchTerm = inputValue;
    this.productState.skip = 0;
    this.getProducts();
  }

  public getProducts() {
    //this.loading = true;
    const page = this.productState.skip / this.productState.take + 1;
    const limit = this.productState.take;

    this.collapseAll();
    this.shopService.getList(page, limit, this.productSearchTerm, this.collection);
  }
  public collapseAll() {
    for( let i = 0; i < this.productState.take; i++ ) {
      this.productGrid.collapseRow(i);
    }
  }
}
